import { LOAD_STATE } from '../constants/loads'
import { IAction, IDriver, ILoad } from '../types'

const DRIVER_LED_STATUSES = [
  LOAD_STATE.Dispatched,
  LOAD_STATE['At Pickup'],
  LOAD_STATE.Loading,
  LOAD_STATE['In Transit'],
  LOAD_STATE['In Yard'],
  LOAD_STATE['At Dropoff'],
  LOAD_STATE.Unloading,
  LOAD_STATE.Delivered,
]

const SHARE_LOAD_STATUSES = [LOAD_STATE['Ready for Dispatch'], LOAD_STATE.Pending]

export const shouldShowOptInModal = (drivers: IDriver[]) =>
  drivers.some(
    driver =>
      !!driver?.settings?.smsStatusUpdatesEnabled === false &&
      !!driver?.settings?.suppressSmsStatusUpdatesOptIn === false
  )

/**
 * Don't display Prompt for Driver-Led Status Updates (for Transfix loads specifically)
 * The driver will receive text reminders automatically, unless the shipment
 * is tracking via app or Project44
 */
export const shouldPromptDriverUpdates = (shipment: ILoad): boolean => {
  const { status, drivers = [], isExternal } = shipment || {}
  return !isExternal && shouldShowOptInModal(drivers) && DRIVER_LED_STATUSES.includes(status)
}

export const shouldPromptShareLoads = (shipment: ILoad): boolean => {
  const { status, drivers = [] } = shipment
  return !!drivers.length && SHARE_LOAD_STATUSES.includes(status)
}

export const getDriversData = (action: IAction) => {
  const { payload } = action || {}
  const { shipment } = payload || {}
  const { drivers = [], id = '' } = shipment || {}
  return { drivers, shipment, id }
}
